import { useCallback } from "react";
import { FieldErrors, Resolver, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { isValidEmail } from "../../../../../../../../common/validations/validationsForm";
import { IEmailItemWithIndex } from "../../../../../../../../models";
import { useAppDispatch } from "../../../../../../../../redux/hooks";
import { compileNameOfProperty } from "../../../../../../../../utils";
import { CustomIcons } from "../../../../../../../common/customIcons/customIcons";
import { FormField } from "../../../../../../../common/fields/fields";
import { UserProfileAdminEmailItemStyle } from "./itemStyle.jss";

interface IProps {
    email: string;
    isLastIndex: boolean;
    isUniqueIndex: boolean;
    index: number;
    updateEmailItem: (value: IEmailItemWithIndex) => any;
    removeEmailItem: (value: number) => any;
    addEmailItem: () => any;
}

interface IEmailItem {
    email: string;
}

export const ManagementUserEmailItem: React.FC<IProps> = ({
    email,
    isLastIndex,
    isUniqueIndex,
    index,
    addEmailItem,
    removeEmailItem,
    updateEmailItem,
}) => {
    const style = UserProfileAdminEmailItemStyle();
    const dispatch = useAppDispatch();
    const { t } = useTranslation("common", { keyPrefix: "MANAGEMENT.FORMS.MANAGEMENT_USER" });

    const emailResolver: Resolver<IEmailItem> = async (values: IEmailItem) => {
        let errors = {};
        Object.entries(values).forEach(([name, value]) => {
            if (name === "email") {
                if (!isValidEmail(value)) {
                    errors = {
                        ...errors,
                        ["email"]: {
                            type: "required",
                            message: "FORM.VALIDATION.EMAIL",
                        },
                    };
                }
            }
        });
        return { values, errors };
    };

    const {
        register,
        formState: { errors: validationErrors, isValid },
    } = useForm<any>({ mode: "onChange", resolver: emailResolver });

    const onInputChange = useCallback(
        (event) => {
            const payload: IEmailItemWithIndex = {
                index: index,
                email: event?.target?.value,
                isValid,
            };
            updateEmailItem(payload);
        },
        [dispatch],
    );

    const onRemoveItem = () => {
        removeEmailItem(index);
    };

    const onAddItem = () => {
        isValid && addEmailItem();
    };

    const emailErrors: FieldErrors<IEmailItem> = validationErrors;


    return (
        <>
            <div className={style.emailContainer}>
                <div className={style.emailContent}>
                    <FormField
                        type="text"
                        label={t("EMAIL")}
                        value={email}
                        error={emailErrors.email}
                        {...register(compileNameOfProperty<IEmailItem>("email"), {
                            onChange: onInputChange,
                            value: email,
                        })}
                        isRequired={true}
                    />
                    {!isUniqueIndex && (
                        <CustomIcons
                            iconName="Cancel"
                            onClick={onRemoveItem}
                        />
                    )}
                </div>
                {isLastIndex && (
                    <div className={style.addEmail}>
                        <CustomIcons
                            iconName="Add"
                            onClick={onAddItem}
                            isDisabled={!isValid}
                        />
                    </div>
                )}
            </div>
        </>
    );
};
